import { authHeader } from "./data";
import { SendVerificationCodeRequest } from "../types/SendVerificationCodeRequest";
import authAxios from "./data";

const fetchUser = async () => {
  const response = await authAxios.get("/api/UserProfile", {
    headers: authHeader(),
  });

  return response.data;
};

const sendVerificationCode = async (request: SendVerificationCodeRequest) => {
  const response = await authAxios.post("/api/VerificationCode/Send", request, {
    headers: authHeader(),
  });

  return response.data;
};

const confirmVerificationCode = async (request: any) => {
  const response = await authAxios.post(
    "/api/VerificationCode/Confirm",
    request,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const changePassword = async (request: any) => {
  const response = await authAxios.post(
    "/api/UserProfile/ChangePassword",
    request,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const changePhone = async (phone: string) => {
  const response = await authAxios.post(
    "/api/UserProfile/ChangePhone",
    {
      phone,
    },
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const changeEmail = async (email: string) => {
  const response = await authAxios.post(
    "/api/UserProfile/ChangeEmail",
    {
      email,
    },
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const fetchHasNotifications = async () => {
  const response = await authAxios.get("/api/UserProfile/hasNewMessages", {
    headers: authHeader(),
  });

  return response.data;
};

export const ProfilesService = {
  fetchUser,
  sendVerificationCode,
  confirmVerificationCode,
  changePassword,
  changePhone,
  changeEmail,
  fetchHasNotifications,
};
